import { getDataFromCmsApi } from "../api/contentful-service";
import DynamicPage from "../components/dynamic-page";
import DivisionHomepageLayout from "../components/layouts/division-homepage-layout";
import GovHubServiceLinks from "../pages/govhub-services/govhub-service-links.js";
import GovHubServices from "../pages/govhub-services/govhub-services.js";
import { govHubSubPath } from "../utils/utils.js";

const fetchDynamicRoutes = async (divisionCode) => {
    try {
        const result = await getDataFromCmsApi(`divisionService/${divisionCode}`);
        const divisionName = result[0]?.division?.divisionName || divisionCode;
        const mappedRoutes = result.map((route) => {
            return {
                path: route?.link || "*",
                component: route?.link?.includes(`${govHubSubPath}/`) ? (
                    <GovHubServices />
                ) : route?.link?.includes(govHubSubPath) ? (
                    <GovHubServiceLinks />
                ) : (
                    <DivisionHomepageLayout
                        division={{
                            tag: divisionCode.toLowerCase(),
                            title: `${divisionName} Division`,
                            divisionAbbreviation: divisionCode
                        }}
                    >
                        <DynamicPage webpageId={route?.webpage?.pageId} parentServiceId={route?.id} />
                    </DivisionHomepageLayout>
                ),
                meta: {
                    title: route.serviceLabel,
                    description: route.shortDescription ?? route.serviceDescription ?? ""
                }
            };
        });

        // console.log(`Mapped routes for ${divisionCode}:`, mappedRoutes);
        return mappedRoutes;
    } catch (error) {
        console.error(`Error fetching routes for ${divisionCode}`, error);
        return [];
    }
};

export default fetchDynamicRoutes;
